import React, { useEffect } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { showToast } from 'redux/slices/Toasts';
import { SnackBarMessage, SnackBarMessageProps } from 'components/SnackBarMessage';
import { Table } from 'components/Table';
import Title from 'components/Title';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getAccountsTable, getStoreGroups } from 'redux/slices/Accounts';
import { RootState } from 'redux/store';

export function Accounts() {
	const dispatch = useAppDispatch();
	const accounts = useAppSelector((state: RootState) => state.account);
	const permissions = useAppSelector((state: RootState) => state.permissions);
	const navigate = useNavigate();
	const [loaded, setLoaded] = React.useState(false);
	const [snackSettings, setSnackSettings] = React.useState<SnackBarMessageProps>(new SnackBarMessageProps());
	const user = useAppSelector((state: RootState) => state.logedinUser);

	useEffect(() => {
		setLoaded(false);
		dispatch(getAccountsTable());
		dispatch(getStoreGroups());
	}, []);


	const columnsb = [
		{
			Header: 'ID',
			accessor: 'id',
			defaultCanSort: true,
			width: 40,
			Cell: (row: any) => user?.permissions?.accounts?.canUpdate ? (<Link to={`/app/account/${row.cell.row.original.id}`}>{row.value}</Link>) : (<>{row.value}</>),
		},
		{
			Header: 'First Name',
			accessor: 'givenName',
			defaultCanSort: true,
			Cell: (row: any) => user?.permissions?.accounts?.canUpdate ? (<Link to={`/app/account/${row.cell.row.original.id}`}>{row.value}</Link>) : (<>{row.value}</>),
		},
		{
			Header: 'Last Name',
			accessor: 'familyName',
			defaultCanSort: true,
			Cell: (row: any) => user?.permissions?.accounts?.canUpdate ? (<Link to={`/app/account/${row.cell.row.original.id}`}>{row.value}</Link>) : (<>{row.value}</>),
		},
		{
			Header: 'Email',
			accessor: 'email',
			defaultCanSort: true,
			Cell: (row: any) => user?.permissions?.accounts?.canUpdate ? (<Link to={`/app/account/${row.cell.row.original.id}`}>{row.value}</Link>) : (<>{row.value}</>),
		},
		{
			Header: 'Status',
			accessor: 'status',
			Cell: (row: any) => {
				return (
					<>
						{row.cell.row.original.status === 'Suspended' && <Badge className="me-1 badge-outline-danger">Suspended</Badge>}
						{row.cell.row.original.status === 'Active' && <Badge className="me-1 badge-outline-primary">Active</Badge>}
					</>
				);
			}
		},
	];

	function addNewRow() {
		navigate("/app/new-account");
	}

	return (
		<>
			<Title pageTitle="Accounts" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										columns={columnsb}
										data={accounts.table}
										errors={accounts.error}
										loading={accounts.loading}
										reloadTableRows={() => dispatch(getAccountsTable())}
										addNewRow={user.permissions.accounts.canCreate ? () => addNewRow() : undefined}
									/>
								</div>
								<SnackBarMessage {...snackSettings} />
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}